import {
  Alert,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TableCell,
  TableRow,
} from "@mui/material";
import RenderEstimateTable from "../../lead/quote/RenderEstimateTable";
import useStyles from "./confirmationStyle";
import {
  leadAncillariesFields,
  leadAncillariesHeading,
  leadEstimateFinalFields,
  leadGenInfoFields,
  leadGenInfoHeading,
  leadGenInoList,
  leadMaterialsFields,
  leadMaterialsHeading,
  leadQuoteSubcontractorFields,
  leadQuoteSubcontractorHeading,
} from "../../lead/leadAllFields";
import { calculateProfit, getTotal } from "../../lead/quote/leadEstimateUtil";

import FormField from "../../../../components/common/FormField";
import { useSelector } from "react-redux";

const QuoteViewData = ({
  formData,
  setFormData,
  subContractorOptions,
  isDisabled,
  isTesterSection,
  error,
}: any) => {
  const classes = useStyles();
  const { sales } = useSelector((state: any) => state.sale);
  const { newFinancialState } = useSelector((state: any) => state.quickBook);
  console.log("formData-40", formData);
  const paymentOptions =
    newFinancialState?.payment_methods?.map((method: any) => ({
      label: method.name,
      value: method.id,
    })) || [];

const handlePaymentChange = (event: any) => {
  const selectedId = event.target.value;

  const selectedPaymentMethod =
    newFinancialState?.payment_methods?.find(
      (method: any) => method.id === selectedId
    );

  if (selectedPaymentMethod) {
    setFormData((prev: any) => ({
      ...prev,
      paymentMethod: selectedPaymentMethod.name,
      paymentMethodId: selectedPaymentMethod.id,
    }));
  }
};

const handleFieldChange = (e: any) => {
  const { id, value } = e.target;

  setFormData((prev: any) => ({
    ...prev,
    [id]: value,
  }));
};

  return (
    <>
      {/* Material */}
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          // opacity: load ? 1 : 0,
          paddingLeft: "0px !important",
          paddingTop: "10px !important",
        }}
      >
        <div
          className={classes.container}
          // style={{
          //   backgroundColor: estimateForm?.requirements?.some(
          //     (req: any) => req.service_name === "material" && req.is_accepted
          //   )
          //     ? "#E3FCEF"
          //     : "none",
          //   background: "#E5F4F1",
          // }}
        >
          {" "}
          <RenderEstimateTable
            {...{
              estimateForm: formData,
              error,
              screenType: "quotation",
              tableHeadding: leadMaterialsHeading,
              tableContent: formData?.materials,
              fields: leadMaterialsFields,
              additionRow: (
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                  <TableCell colSpan={2}>
                    <FormControlLabel
                      label="Material Price Chargeable"
                      labelPlacement="start"
                      control={
                        <Checkbox
                          sx={{
                            marginTop: "16px",
                            marginLeft: "6px !important",
                            width: "auto !important",
                          }}
                          checked={formData?.materialPriceChargeable}
                          disabled={true}
                          // onChange={(e: any) => onChangeAction(e)}
                          name="materialPriceChargeable"
                          id="materialPriceChargeable"
                          color="primary"
                        />
                      }
                      sx={{
                        marginLeft: "0px !important",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "13px", // Set your desired font size here
                          display: "flex",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    £{getTotal("total", formData).toLocaleString("en-GB")}
                  </TableCell>

                  <TableCell sx={{ fontWeight: 600 }}>
                    {getTotal("volume", formData)}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    £{getTotal("cost", formData).toLocaleString("en-IN")}
                  </TableCell>
                </TableRow>
              ),
              section: "materials",
              disabled: true,
            }}
          />
        </div>
      </Grid>

      {/* Charges */}
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          // opacity: load ? 1 : 0,
          paddingLeft: "0px !important",
          background: "#E5F4F1",
          borderRadius: "5px",
          border: "1px solid #ddd",
          marginTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
          <Grid
            item
            xs={12}
            sm={3.5}
            sx={{
              paddingLeft: "0px !important",
              pointerEvents: "none",
              cursor: "not-allowed",
              opacity: 0.8,
            }}
          >
            <div className={classes.container}>
              <RenderEstimateTable
                {...{
                  estimateForm: formData,
                  error,
                  tableHeadding: leadGenInfoHeading,
                  tableContent: leadGenInoList,
                  fields: leadGenInfoFields,
                  additionRow: null,
                  section: "generalInfo",
                  disabled: true,
                }}
              />
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            sm={3.5}
            sx={{
              paddingLeft: "0px !important",
              pointerEvents: "none",
              cursor: "not-allowed",
              opacity: 0.8,
            }}
          >
            <div className={classes.container}>
              <RenderEstimateTable
                {...{
                  estimateForm: formData,
                  tableHeadding: leadAncillariesHeading,
                  tableContent: formData?.ancillaries,
                  fields: leadAncillariesFields,
                  additionRow: (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {getTotal("ancillaries", formData)}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  ),
                  section: "ancillaries",
                  disabled: true,
                }}
              />
            </div>
          </Grid>
          {/* Subcontractor */}
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              paddingLeft: "0px !important",
              pointerEvents: "none",
              cursor: "not-allowed",
              opacity: 0.8,
            }}
          >
            <div className={classes.container}>
              <RenderEstimateTable
                {...{
                  estimateForm: formData,
                  subContractorOptions,
                  error,
                  tableHeadding: leadQuoteSubcontractorHeading,
                  tableContent: formData?.subcontractorCharges,
                  fields: leadQuoteSubcontractorFields,
                  additionRow: (
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          paddingTop: "10px!important",
                        }}
                      ></TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {getTotal("subcontractorCharges", formData)}
                      </TableCell>
                    </TableRow>
                  ),
                  section: "subcontractorCharges",
                  disabled: isDisabled || true,
                }}
              />
            </div>
          </Grid>
        </Grid>

        {/* payment method */}

        <>
          <Grid
            container
            spacing={1}
            sx={{
              marginLeft: "0px !important",
              width: "100% !important",
              paddingTop: "10px",
            }}
          >
            <Grid
              item
              xs={12}
              sm={1.5}
              className={classes.labelBox}
              alignItems="center"
              sx={{
                margin: "0!important",
                display: "flex",
                alignItems: "center",
                paddingLeft: "14px !important",
              }}
            >
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "17px",
                  textWrap: "wrap",
                  lineHeight: 1.1,
                }}
                shrink
                htmlFor={"paymentMethod"}
              >
                Payment method
              </InputLabel>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              style={{
                padding: "0px 0px 0px 8px",
                display: "flex",
                justifyContent: "center",
                paddingLeft: "16px !important",
              }}
            >
              <FormField
                onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                  e.preventDefault()
                }
                {...{
                  id: "paymentMethod",
                  type: "select",
                  variant: "outlined", // Adding this variant prop
                  isNonMarginTop: true,
                  value: (() => {
                    if (formData?.paymentMethodId) {
                      return formData.paymentMethodId;
                    }

                    if (formData?.paymentMethod) {
                      const method = newFinancialState?.payment_methods?.find(
                        (m: any) => m.name === formData.paymentMethod,
                      );
                      return method ? method.id : "";
                    }

                    return "";
                  })(),
                  options: newFinancialState?.payment_methods ?? [],
                  disabled: false,
                  InputProps: {
                    sx: {
                      padding: "2px 4px",
                      height: "36px",
                    },
                  },

                  onChange: (e: any) => handlePaymentChange(e),
                  onBlur: () => {},
                }}
              />
            </Grid>
          </Grid>
        </>

        {/* final field */}
        <div
          style={{
            padding: "10px 10px 0 10px",
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              paddingLeft: "0px !important",
            //   pointerEvents: "none",
            //   cursor: "not-allowed",
            //   opacity: 0.8,
            }}
          >
            {leadEstimateFinalFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label}
                    </InputLabel>
                  </Grid>
                );
              }

              // default input field
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  onKeyDown={(event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return;

                    if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(
                        event.target.value + event.key,
                      )
                    ) {
                      event.preventDefault();
                    }
                  }}
                  {...{
                    ...field,
                    id: field?.id,
                    label: field?.label?.["quotation"],
                    variant: "outlined", // Adding this variant prop
                    // value: field?.id ==='quoteExpiresOn' ? screenType === "quotation"
                    // ? dayjs().add(3, "months")
                    // : ""
                    value:
                      field?.id === "quoteTotal" || field?.id === "costTotal"
                        ? Number(
                            formData?.[field.id as keyof typeof formData] ?? 0,
                          ).toLocaleString("en-GB")
                        : field?.id === "profit"
                          ? calculateProfit(
                              formData?.quoteTotal,
                              formData?.costTotal,
                            )
                          : formData &&
                            formData[field.id as keyof typeof formData],
                    isNonMarginTop: true,
                    disabled:
                        field?.id === "contentValue"
                        ? false
                        : field?.disabled || true,
                    GridFieldStyle: {
                      ...field?.GridFieldStyle,
                      paddingLeft:
                        field?.id === "quoteTotal" ||
                        field?.id === "contentValue"
                          ? "0px !important"
                          : field?.id === "costTotal" ||
                              field?.id === "profit" ||
                              field?.id === "accepted_status"
                            ? "5px !important"
                            : "0px !important",
                    },
                    InputProps: {
                      ...field?.inputProps,
                      sx: {
                        // ...field?.inputProps?.sx,
                        padding: "2px 4px",
                        height: "36px",
                      },
                    },
                    onChange: (e: any) => handleFieldChange(e),
                    onBlur: () => {},
                    error: error && error?.[field?.id],
                  }}
                />
              );
            })}
            {/* profile section */}
            {Number(sales?.minimum_profit_level) >
              calculateProfit(formData?.quoteTotal, formData?.costTotal) && (
              <Grid item xs={6}>
                <Alert
                  severity="warning"
                  sx={{ padding: "4px 10px", marginTop: "12px" }}
                >
                  Warning profit is below minimum set
                </Alert>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default QuoteViewData;
